import React from "react";
import { useLanguage } from "../../hooks/useLanguage";
import IMAGE_PRINCIPAL from "../../images/image-principal.webp"
import { StarBackground } from "../ui/StarBackground";
import { SocialDock } from "../ui/SocialDock";
import "./home-style.scss";
import { motion } from "framer-motion";

export const Home = () => {
  const { translations: t } = useLanguage();
  const HOME = t.home;
  
  return (
    <div className="home_container">
      {/* Nuevo fondo 3D de partículas */}
      <StarBackground />
      
      {/* Formas de fondo originales reducidas en opacidad para complementar */}
      <div className="background_shapes">
        <div className="shape shape_1"></div>
        <div className="shape shape_2"></div>
      </div>
      
      <div className="content_wrapper">
        <section className="text_section">
          {HOME.map((text, index) => (
            <div className="text_content" key={index}>
              <motion.span 
                className="greeting"
                initial={{ opacity: 0, x: -50 }}
                animate={{ opacity: 1, x: 0 }}
                transition={{ duration: 0.5 }}
              >
                {text.title}
              </motion.span>
              
              <h1 className="main_title">
                {text.subtitle}
              </h1>
              
              <motion.p 
                className="description"
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5, delay: 1 }}
              >
                {text.paragraph}
              </motion.p>
              
              <motion.div 
                className="cta_container"
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5, delay: 1.2 }}
              >
                <a href="/contact" className="primary_btn">{t.header[4].content}</a>
                <SocialDock />
              </motion.div>
            </div>
          ))}
        </section>
        
        <aside className="image_section">
          <motion.div 
            className="image_wrapper"
            initial={{ opacity: 0, scale: 0.8 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.8, delay: 0.5 }}
          >
            <img className="hero_image" src={IMAGE_PRINCIPAL} alt="Jonathan Cocuy" />
            <div className="image_backdrop"></div>
          </motion.div>
        </aside>
      </div>
    </div>
  );
};
